import { render } from "./PostFooterComponent.vue?vue&type=template&id=717dd09b&scoped=true&ts=true"
import script from "./PostFooterComponent.vue?vue&type=script&lang=ts"
export * from "./PostFooterComponent.vue?vue&type=script&lang=ts"

import "./PostFooterComponent.vue?vue&type=style&index=0&id=717dd09b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717dd09b"]])

export default __exports__